<script setup lang="ts">
import { computed } from 'vue'
import { itemScopeAttributes, useModelStrings, type ItemTemplateProps } from '@jantm/model-core'
import type {ContactPerson} from "@/types/Wiser/contactPerson.ts";
import {useRouter} from "vue-router";

/**
 * Custom item rendering for ContactPerson.
 *
 * Narrowing `entity` to `ContactPerson` is the whole point of a per-model template: the
 * props contract stays the one model-core passes, but inside this file the
 * entity is fully typed.
 */
const props = withDefaults(defineProps<ItemTemplateProps<ContactPerson>>(), { headingLevel: 3 })

const { t, locale } = useModelStrings(() => props.definition)

const scope = computed(() => itemScopeAttributes(props.definition))
const heading = computed(() => `h${props.headingLevel}` as const)
const router = useRouter()
const entityId = computed(() => props.entity?.id ?? 0)
const gotoDetail = function() {
  router.push({name: 'wiser-contact-person', params: {id: entityId.value}})
}
</script>

<template>
  <article
    class="wiser-item contactPerson-item"
    v-bind="scope"
    @click="gotoDetail"
  >
    <component
      :is="heading"
      class="wiser-item__title contactPerson-item__title"
    >
      <span>{{ entity.id }}</span>
    </component>
    <span>{{ entity.voornaam }} {{ entity.tussenvoegsel }} {{ entity.achternaam }}</span>
  </article>
</template>
